import { useQuery } from 'react-query'
import { useMemo } from 'react'
import useQueryString from '@hooks/useQueryString'
import { indexXenPlatforms } from '@lib/axios/xenplatform'

function useIndex() {
  const { params } = useQueryString()
  const { status, data } = useQuery(
    ['saas-xenplatforms', params],
    () => indexXenPlatforms(params),
    {
      retry: false,
      staleTime: Infinity,
      keepPreviousData: true,
    }
  )
  // const mapper = (({ status, ...d }) =>
  // ({ status: status ? 'terhubung' : 'tidak terhubung', ...d }))

  const tableData = useMemo(
    () => ((status === 'success' && Array.isArray(data?.data?.data)) ? data?.data?.data : []),
    [status, data]
  )

  const emptyPagination = useMemo(() => ({
    current_page: 1,
    first_page: true,
    last_page: false,
    next_page: null,
    prev_page: null,
    total_pages: 1,
  }), [])

  const tablePagination = useMemo(
    () => ((status === 'success' && data?.data?.pagination) ? data?.data?.pagination : emptyPagination),
    [status, data, emptyPagination]
  )

  const columns = [
    ['id', 'ID', true],
    ['public_profile.business_name', 'Nama Bisnis', false],
    ['email', 'Email', false],
    ['account_type', 'Tipe Akun', false],
    ['status', 'Status', false],
    ['created_at', 'created_at ', true],
    ['updated_at', 'updated_at', true],
  ]

  const tableColumns = columns
    .map(([column, title]) => ([column, title]))
    .map(([accessor, Header]) => ({ accessor, Header }))

  const hiddenColumns = columns
    .filter(([, , hidden]) => hidden)
    .map(([column]) => column)

  return {
    tableData,
    tableColumns,
    hiddenColumns,
    tablePagination,
  }
}

export default useIndex
